export default __webpack_public_path__ + "static/media/P941_B_BD.968fc2b6.pdf";